import { brandLinka } from '@ads/tokens';
import { DashboardPaymentMethodSales } from '@linka/domain/dtos';
import { useTranslation } from '@linka/i18n';
import { Pie, PieChart } from 'recharts';
import {
  ChartContainer,
  ChartLegend,
  ChartLegendContent,
  ChartTooltip,
  ChartTooltipContent,
} from '../../../chart/chart';
import { ChartCard, ChartCardContent, ChartCardHeader, ChartCardTitle, ExportChartTriggerButton } from '../components';

interface SalesByPaymentMethodProps {
  data: DashboardPaymentMethodSales;
}
export const SalesByPaymentMethod = ({ data }: SalesByPaymentMethodProps) => {
  const t = useTranslation();
  return (
    <ChartCard>
      <ChartCardHeader>
        <ChartCardTitle>{t('dashboard.charts.sales-by-payment-method')}</ChartCardTitle>
        <ExportChartTriggerButton type='OVERVIEW_SALES_BY_PAYMENT_METHOD' />
      </ChartCardHeader>
      {data.data.length === 0 ? (
        <ChartCardContent className='flex flex-1 items-center justify-center py-xl'>
          <span className='ts-paragraph-xs text-ctx-content-base'>{t('dashboard.charts.no-data')}</span>
        </ChartCardContent>
      ) : (
        <ChartCardContent>
          <ChartContainer
            config={{
              PIX: { label: t('PIX'), color: brandLinka.baseColor.brand['400'] },
              CREDIT_CARD: { label: t('CREDIT_CARD'), color: brandLinka.contextualColor.interactive.primary },
              BOLETO: { label: t('BOLETO'), color: brandLinka.baseColor.accent['400'] },
              FREE: { label: t('FREE'), color: brandLinka.baseColor.gray['400'] },
              GOOGLE_PAY: { label: t('GOOGLE_PAY'), color: '#4285F4' },
              null: { label: 'Outros', color: brandLinka.baseColor.gray['700'] },
            }}
            className='min-h-[200px] w-full'
          >
            <PieChart
              data={data.data.map((item) => ({
                ...item,
                paymentMethod: String(item.paymentMethod),
                fill: `var(--color-${item.paymentMethod})`,
              }))}
              responsive
              accessibilityLayer
            >
              <Pie innerRadius={50} dataKey='ordersCount' nameKey='paymentMethod' minAngle={10} label />
              <ChartTooltip content={<ChartTooltipContent hideLabel />} />
              <ChartLegend content={<ChartLegendContent />} />
            </PieChart>
          </ChartContainer>
        </ChartCardContent>
      )}
    </ChartCard>
  );
};
